import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return "Er ging iets mis. Probeer het opnieuw.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => (typeof x?.msg === "string" ? x.msg : JSON.stringify(x))).filter(Boolean).join(" · ");
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
}

export const eur = (v) => new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR" }).format(v || 0);

export const MUSIC_PRIMARY = "https://cdn.pixabay.com/audio/2022/05/27/audio_1808fbf07a.mp3";
export const MUSIC_FALLBACK = "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-9.mp3";

export default api;
